module.exports = __webpack_public_path__ + "img/new_banner_bg.460d8279.png";